import { fetchJson } from "../../../../utils/";
import { ApiResponse } from "./models";
import { constants } from "../../common";
import { reportError } from "../../basket-v2/errorReporting";

export async function abandonBasket() {
  const { success, errors } = await fetchJson<ApiResponse>(constants.urls.basketV2.abandon, {
    method: "DELETE",
  });

  if (success) {
    return true;
  } else {
    reportError("ft", errors.map((e) => e.message).join(", "));
    return false;
  }
}
